import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import Cookies from 'js-cookie';

// Token validity check
const isTokenValid = (token) => {
  const decodedToken = JSON.parse(atob(token.split('.')[1]));
  const currentTime = Math.floor(Date.now() / 1000); // Current time in seconds
  return decodedToken.exp > currentTime; // Compare expiration time with current time
};

// Check if token is expiring soon
const TOKEN_REFRESH_THRESHOLD = 2; // Threshold for token expiration (in seconds)

const isTokenExpiringSoon = (token) => {
  const decodedToken = JSON.parse(atob(token.split('.')[1]));
  const currentTime = Math.floor(Date.now() / 1000);
  return decodedToken.exp - currentTime < TOKEN_REFRESH_THRESHOLD;
};
const PrivateRoute = ({ children, adminOnly }) => {
  const tokenAccess = Cookies.get('tokenAccess');
  const tokenRefresh = Cookies.get('tokenRefresh');
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { logout: isLoggedOut} = useSelector(state => state.auth);
  const [isAdmin, setIsAdmin] = useState(false);
  
  useEffect(() => {

    const handleLogout = (message) => {
      Cookies.remove('tokenAccess');
      Cookies.remove('tokenRefresh');
      navigate('/login', { replace: true });
    };

    // // Ελέγξτε για το token και την κατάσταση admin
    // Έλεγχος για refresh token
    if (tokenRefresh) {
      try {
        // Έλεγχος αν το refresh token έχει λήξει
        if (!isTokenValid(tokenRefresh)) {
          handleLogout('Your session has expired. Please log in again.');
          return;
        }

        // Έλεγχος αν το refresh token πλησιάζει να λήξει
        if (isTokenExpiringSoon(tokenRefresh)) {
          handleLogout('Your session is about to expire. Please log in again.');
          return;
        }

        // Έλεγχος για access token
        if (tokenAccess) {
          const decodedAccess = JSON.parse(atob(tokenAccess.split('.')[1]));
          setIsAdmin(decodedAccess.is_admin); // Ενημέρωση admin κατάστασης
        } else {
          //console.error('66');
          // Redirect to login αν δεν υπάρχει access token
          navigate('/login', { replace: true });
        }
      } catch (error) {
        //console.error('Invalid refresh token', error);
        handleLogout('Invalid refresh token. Please log in again.');
      }
    } else {
      // Redirect to login αν δεν υπάρχει refresh token
      navigate('/login', { replace: true });
    }

    // Admin-only routing
    if (adminOnly && !isAdmin) {
      navigate('/user', { replace: true });
    } else if (!adminOnly && isAdmin) {
      navigate('/admin', { replace: true });
    }
  }, [tokenAccess, isLoggedOut, dispatch, navigate, adminOnly, isAdmin, tokenRefresh]);

  // Καταργήστε τα children εάν ο χρήστης έχει πιστοποιηθεί και δεν αποσυνδεθεί
  return tokenAccess && !isLoggedOut ? children : null;
};

export default PrivateRoute;
